<script>
import WootSnackbar from './Snackbar.vue';

export default {
  components: {
    WootSnackbar,
  },
  props: {
    duration: {
      type: Number,
      default: 2500,
    },
  },

  data() {
    return {
      snackMessages: [],
      // Monotonic counter — `Date.now()` has 1 ms resolution, so two toasts
      // emitted in the same tick (e.g. Apply + the system success message)
      // would collide on `key`. The `findIndex` removal then deletes the wrong
      // message or leaves an orphan stuck on screen. Counter guarantees a
      // unique key per toast regardless of timing.
      nextToastKey: 0,
    };
  },

  mounted() {
    this.$emitter.on('newToastMessage', this.onNewToastMessage);
  },
  beforeDestroy() {
    this.$emitter.off('newToastMessage', this.onNewToastMessage);
  },
  methods: {
    onNewToastMessage({ message, action, duration }) {
      this.nextToastKey += 1;
      const key = this.nextToastKey;
      this.snackMessages.push({ key, message, action });
      // `??` (not `||`) so a caller can pass `0` and have setTimeout fire on the
      // next tick (effectively "remove immediately"), instead of silently being
      // swapped for `this.duration`. Only `null` / `undefined` should fall back
      // to the component default. To implement a truly persistent toast in the
      // future, prefer a `null`-or-sentinel `duration` branch that skips
      // setTimeout entirely — that doesn't exist today.
      window.setTimeout(() => {
        const idx = this.snackMessages.findIndex(m => m.key === key);
        if (idx !== -1) this.snackMessages.splice(idx, 1);
      }, duration ?? this.duration);
    },
  },
};
</script>

<template>
  <transition-group
    name="toast-fade"
    tag="div"
    class="left-0 my-0 mx-auto max-w-[25rem] overflow-hidden absolute right-0 text-center top-4 z-[9999]"
  >
    <WootSnackbar
      v-for="snackMessage in snackMessages"
      :key="snackMessage.key"
      :message="snackMessage.message"
      :action="snackMessage.action"
    />
  </transition-group>
</template>
